import {
  TRADE_DOCUMENTS_FETCH_SUCCESS,
  TRADE_DOCUMENTS_FETCH_FAILURE,
  TRADE_DOCUMENTS_FILTER,

  RECEIVE_USER_TRADE_DOCUMENT, // fix me on phase 7
} from './actionTypes';

let initialState = {
  // for index pages/actions
  all: [],
  type: null,
  defaultFilterIndex: 0,
  filter: '',

  // for show pages/actions
  current: {},
  currentType: null,

  purchaseOrders: [],
  invoices: [],
}

export default function tradeDocuments(state = initialState, action) {
  switch(action.type) {
    case TRADE_DOCUMENTS_FETCH_SUCCESS:
      let newState = {...state, defaultFilterIndex: action.payload.filterIndex}
      newState[action.payload.docType] = action.payload.data;
      return newState;
    case TRADE_DOCUMENTS_FETCH_FAILURE:
      return {...state};
    case TRADE_DOCUMENTS_FILTER:
      let collection = filterByStage(action.payload.filter, state[action.payload.docType]);
      let filteredState = {...state, filter: action.payload.filter};
      filteredState[action.payload.docType] = collection;
      return filteredState;

    case RECEIVE_USER_TRADE_DOCUMENT:
      return {
        ...state,
        current: action.payload,
      };
    default:
      return state;
  }
}

function filterByStage(value, collection) {
  if(value === '') return collection;

  if(value === 'action_required') {
    return collection.filter((item) => { return item.action_required === true; });
  } else {
    return collection.filter((item) => { return item.stage === value; });
  }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/reducers.js